import ormTransform from './ormTransform'
import env from '../env'
import { keyBy, uniqBy } from '@dt/fe-utils/dist/lodash'
import axios from 'axios'
import { ddayjs, format } from '@dt/fe-utils'
import { cartMobx, storeMobx } from 'restaurant'
import { memberMobx } from '@mobxStore'

export default class ProductAPI {
  static getProductColorAndSort () {
    return Promise.resolve({})
  }
  static saveProductColorAndSort (colorData: any, sortData: any, categoriesColorData: any) {
    return Promise.resolve({})
  }
  /** 获取餐品停售状态 */
  static getProductSale (brandId: number, storeId: number, isToday?: boolean) {
    const url = `${env.JMOBILE}/getInventoryByStore`
    const params = {
      brandId,
      storeId
    }
    if (!storeId) {
      return Promise.resolve([])
    }
    return axios.post(url, params).then((data: any) => {
      if (data?.result?.content) {
        let _list = data?.result?.content
        let _autoRestoreMap = keyBy(_list.filter(item => !!item.autoRestore), i => `${i.productNo}_${i.scaleNo}`)
        _list = _list?.map(item => {
          const psMap = []
          const { notForSaleValue, notForSaleValueScale } = item
          notForSaleValue?.forEach((p, index) => {
            notForSaleValueScale?.[index].forEach(s => {
              psMap.push(`${p}_${s}`)
            })
          })
          if (item.notForSaleReason === 'comboChildPause' && item.status === 'NotForSale' && psMap?.length && psMap?.every(i => !!_autoRestoreMap[i])) {
            item.autoRestore = _autoRestoreMap?.[psMap[0]]?.autoRestore
          }
          return item
        })
        return _list?.filter(item => {
          if (!isToday && !!item.autoRestore) {
            return false
          }
          return true
        })
      } else {
        throw data
      }
    })
  }
  static setProductSale (data: IProductSale[]) {
    const url = `${env.POSMOBILE}/product/updateProductStatus`
    const saveData = {
      brandId: storeMobx.info.brandId,
      storeId: storeMobx.info.storeId,
      productItem: data.map(d => {
        return {
          productNo: d.productNo,
          productScaleNo: d.productNo,
          stockInit: d.stockInit,
          stock: d.stock
        }
      })
    }
    return axios.post(url, saveData).then((data) => {
    }).catch(res => {
      return res
    })
  }
  static getAllProduct () {
    return Promise.resolve({} as any)
  }
  static setAutoSoldOut () {
    return Promise.resolve({} as any)
  }
  static getNoMaterialProductByStore () {
    return Promise.resolve({} as any)
  }

  static _hackForMaxCnt (modifierGroups: IModifierGroup[]) {
    if (modifierGroups && modifierGroups.length) {
      modifierGroups.forEach(modifierGroup => {
        modifierGroup.maxCnt = modifierGroup.maxCnt || -1
        modifierGroup.modifiers.forEach(modifier => {
          modifier.maxCnt = modifier.maxCnt || 1
        })
      })
    }
  }

  /** 获取菜单餐品 */
  static getProduct (brandId: number, storeId: number, option: {
    // eatType?: TEatType;
    channel?: 'mobile' | 'pos' | 'pickup';
    eatType?: TEatType;
    menuBeginTime?: string;
    menuBeginDate?: string;
    avatar?: 0 | 1;
    sale?: 0 | 1;
  } = {}) {
    // const url = `${env.POSMOBILE}/product/listProductByStore`
    const url = `${env.POSMOBILE}/product/listProductByStore_v2`
    const params = {
      brandId: String(brandId),
      storeId: String(storeId),
      menuBeginTime: option.menuBeginTime || undefined,
      menuBeginDate: option.menuBeginDate || undefined,
      channel: option.channel || 'mobile',
      eatType: option.eatType,
      avatar: String(option.avatar),
      sale: String(option.sale),
    }
    if (!params.menuBeginTime) {
      delete params.menuBeginTime
    }
    return axios.post(url, { ...params }).then((res: any) => {
      const currentMenu = res.result.content && res.result.content.length ? res.result.content[0] : {}
      return res.result.allMenuTime.map((menu: any) => {
        if (menu.menuBeginTime === currentMenu.menuBeginTime) {
          menu = currentMenu
        } else {
          return {
            begin: menu.menuBeginTime.replace(':', '') + '00',
            end: menu.menuEndTime.replace(':', '') + '00',
            noLoad: true
          }
        }
        const data = menu.content
        const categories: any[] = []
        const categoryMap: { [categoryNo: string]: any } = {}
        const transProductData = ormTransform.clearKey(data, 'product').map((product: any) => {
          // 处理统计分类 (category是显示分类，statisticsCategory是统计分类)
          const sortInCategory = {}
          product.categories = product.categoryDetail ? product.categoryDetail.map((detail: any) => {
            sortInCategory[detail.productCategoryNo] = detail.sort
            return detail.productCategoryNo
          }) : []
          // 在显示分组的排序
          product.sortInCategory = sortInCategory
          product.statisticsCategoryNo = product.categoryNo
          delete product.categoryId
          delete product.categoryNo
          if (product.categoryDetail) {
            product.categoryDetail.forEach((category: any) => {
              if (!categoryMap[category.productCategoryNo]) {
                categoryMap[category.productCategoryNo] = category
                if (category?.customSetting === 0) {
                  category.title = ''
                  category.categoryDesc = ''
                }
                categories.push({ no: category.productCategoryNo, name: category.name, title: category.title, desc: category.categoryDesc, pic: category.pic, isRequired: !!category.isRequired, categorySort: category.categorySort || 0 })
              }
            })
          }
          // 处理把口味组 modifierGroup | undefined -> modifierGroups
          product.modifierGroups = product.modifierGroup || []
          product.scaleGroup = product.scaleGroup || { scales: [] }
          delete product.modifierGroup
          // 兼容老的口味规格数据
          this._hackForMaxCnt(product.modifierGroups)
          product.scaleGroup.scales.forEach((scale: any) => {
            if (scale.scalePic) {
              try {
                scale.picArr = JSON.parse(scale.scalePic || '[]')
                scale.picArr = scale.picArr.filter(item => !!item)
                scale.picArr.length === 1 && scale.picArr.push(scale.picArr[0])
                delete scale.scalePic
              } catch (e) {
              }
            }
            // mock gsd-多规格-中杯
            // if (scale.no === 'f01eb2a2-3a41-4acd-955c-f422a907dca7') {
            //   scale.status = 'disable'
            // }
            this._hackForMaxCnt(scale.modifierGroups)
          })
          // 处理把过敏源 allergy -> allergys
          product.allergys = (product.allergy || []).map((item: any) => {
            item.id = item.id || item.productAllergyId
            return item
          })
          // 处理把标签 tag -> tags
          product.tags = (product.tag || []).map((item: any) => {
            item.id = item.id || item.productAllergyId
            return item
          })
          // 模拟先加入长宽
          if (product.pic) {
            const info = format.toPic(product.pic)
            product.picWidth = info.w || 100
            product.picHeight = info.h || 100
            // product.pics = product.pic
            try {
              product.pics = JSON.stringify(JSON.parse(product.pic).filter(item => !!item || !!item.url))
            } catch (e) {
              product.pics = JSON.stringify([{ url: product.pic, type: 'image', default: 1, w: null, h: null }])
            }
            product.pic = info.url
          } else {
            product.pic = ''
            product.picWidth = 0
            product.picHeight = 0
          }
          product.isCanTogo = product.isCanTogo === undefined || !!product.isCanTogo
          product.taxInPrice = !!product.taxInPrice
          product.isShowInMenu = product.showInMenu !== 0
          product.isSingleSale = product.isSingleSale !== 0
          product.isNotSingleInCombo = !product.noSell
          // 统计销量、购买人
          product.statSaleCnt = product.saleCnt
          product.statAvatar = product.avatar
          delete product.saleCnt
          delete product.avatar
          // 处理套餐
          if (product.group?.length) {
            product.productGroups = product.group.sort((a, b) => (b.sort !== undefined ? b.sort : 9999) - (a.sort !== undefined ? a.sort : 9999)).map((item: any) => {
              item.productGroupDetails = (item.detailList || []).sort((a, b) => (b.sort !== undefined ? b.sort : 9999) - (a.sort !== undefined ? a.sort : 9999))
              delete item.productGroupDetailList
              delete item.detailList
              return item
            })
          }
          delete product.group
          delete product.allergy
          delete product.tag
          delete product.categoryDetail
          /** 排序规格组 */
          product.scaleGroup.scales.sort((a, b) => (b.sort || 9999) - (a.sort || 9999))
          /** 排序口味组 */
          product.modifierGroups.sort((a, b) => {
            a.modifiers.map((c, d) => (d.sort || 9999) - (c.sort || 9999))
            return a.index === 9999 ? (ddayjs(a.addTime).valueOf() - ddayjs(b.addTime).valueOf()) : (a.index - b.index)
          })
          // keep taxCategoryId
          product.taxCategoryId = product.taxCategoryId || 0
          /** 排序 */
          return product
        })
        // 在api层把默认排序处理完
        categories.sort((a, b) => b.categorySort - a.categorySort)
        categories.forEach(c => delete c.categorySort)
        // 处理23:59 -> 24:00
        if (menu.menuEndTime === '23:59') {
          menu.menuEndTime = '24:00'
        }
        return {
          begin: menu.menuBeginTime.replace(':', '') + '00',
          end: menu.menuEndTime.replace(':', '') + '00',
          product: uniqBy(transProductData, 'no'), // TODO 当前后端可能会返回异常的数据，这边做了过滤处理
          category: categories
        }
      })
    })
  }
  /** 获取热搜餐品 */
  static getHotProduct (startTime: string, endTime: string) {
    const url = `${env.REPORT}/report/jl-pos-product-rank/`
    const params = {
      params: {
        store_id: storeMobx.info.storeId,
        start_time: startTime,
        end_time: endTime
      },
    }
    return axios.post(url, params).then((res: any) => {
      return (res.result.content || []).map((v: any) => {
        return {
          qty: v.qty,
          no: v.product_no
        }
      })
    }).catch((err) => err)
  }
  /** 获取用户买过餐品 */
  static getBoughtProduct () {
    const url = `${env.POSMOBILE}/product/listProductBought`
    const params = {
      // storeId: storeMobx.info.storeId
    }
    return axios.get(url, { params }).then((res: any) => {
      return (res.result || []).map((v: any) => {
        return {
          no: v.productNo,
          cnt: v.orderCnt
        }
      })
    }).catch((err) => err)
  }
  /** 获取购物车推荐 */
  static getRecommendCart (isNoCart: boolean = false) {
    const url = `${env.RECOMMEND}/recommend/cart`
    const params = {
      store_id: storeMobx.info.storeId,
      brand_id: storeMobx.info.brandId,
      order_time: ddayjs().format('HH:mm'),
      member_id: memberMobx.memberInfo.memberId,
      cart: isNoCart ? [] : (cartMobx.cartItems || []).map(({ productNo }) => productNo)
    }
    return axios.post(url, params).then((res: any) => {
      return res
    }).catch((err) => err)
  }

  /** 获取餐品预约时间 */
  static getProductReserveRule () {
    const url = `${env.JMOBILE}/product/productReserve/list`
    const params = {
      brandId: storeMobx.info.brandId,
      storeId: storeMobx.info.storeId,
    }
    return axios.post(url, params).then((res: any) => {
      return res?.result
    }).catch((err) => err)
  }

  static getStoreAllProducts () {
    return Promise.resolve({})
  }
}
